@property --eo-e1-y {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 81%;
}
@property --eo-e2-y {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 122%;
}
@property --eo-e3-y {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 114%;
}
@property --eo-e4-y {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 124%;
}
@property --eo-e5-y {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 84%;
}

@keyframes eo-pulse-1 {
  0%,
  100% {
    --eo-e1-y: 81%;
  }
  50% {
    --eo-e1-y: 95%;
  }
}
@keyframes eo-pulse-2 {
  0%,
  100% {
    --eo-e2-y: 110%;
  }
  50% {
    --eo-e2-y: 97%;
  }
}
@keyframes eo-pulse-3 {
  0%,
  100% {
    --eo-e3-y: 103%;
  }
  50% {
    --eo-e3-y: 92%;
  }
}
@keyframes eo-pulse-4 {
  0%,
  100% {
    --eo-e4-y: 112%;
  }
  50% {
    --eo-e4-y: 98%;
  }
}
@keyframes eo-pulse-5 {
  0%,
  100% {
    --eo-e5-y: 84%;
  }
  50% {
    --eo-e5-y: 98%;
  }
}

.videoWrapper {
  position: absolute;
  inset: 0;
}

.maskedVideo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.85;

  -webkit-mask-image:
    radial-gradient(
      ellipse 24% 55% at 0% var(--eo-e1-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 26.5% var(--eo-e2-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 50% var(--eo-e3-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 74% var(--eo-e4-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 100% var(--eo-e5-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    );
  mask-image:
    radial-gradient(
      ellipse 24% 55% at 0% var(--eo-e1-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 26.5% var(--eo-e2-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 50% var(--eo-e3-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 74% var(--eo-e4-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 24% 55% at 100% var(--eo-e5-y),
      black 30%,
      rgba(0, 0, 0, 0.7) 50%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    );

  animation:
    eo-pulse-1 6s ease-in-out infinite,
    eo-pulse-2 7s ease-in-out infinite,
    eo-pulse-3 8s ease-in-out infinite,
    eo-pulse-4 7.5s ease-in-out infinite,
    eo-pulse-5 6.5s ease-in-out infinite;
}
